import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'component-sheet-page',
  templateUrl: './component-sheet-page.component.html',
  styleUrls: ['./component-sheet-page.component.scss']
})
export class ComponentSheetPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
